export const getOptions = (
  options: Record<string, string>,
  values: string[],
) => {
  const hasGlobal = values.includes("Global");
  const hasIngka = values.includes("INGKA");
  return Object.entries(options).map(([value, label]) => {
    const isDisabled =
      (hasGlobal && value !== "Global") || (hasIngka && value !== "INGKA");
    return {
      label,
      value,
      isDisabled,
    };
  });
};

export const validateOutput = (values: string[]) => {
  const hasGlobal = values.includes("Global");
  const hasIngka = values.includes("INGKA");
  return values.filter(
    (value) =>
      (hasGlobal && value === "Global") ||
      (hasIngka && value === "INGKA") ||
      (!hasGlobal && !hasIngka),
  );
};
